import React from 'react';
import { Target, Users, Trophy } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <Target className="h-12 w-12 text-blue-500" data-id="element-60" />,
    title: 'Profile Showcase',
    description: 'Highlight your skills, achievements, and career milestones'
  }, {
    icon: <Users className="h-12 w-12 text-blue-500" data-id="element-61" />,
    title: 'Network Building',
    description: 'Connect with teams, scouts, players, journalists and sponsors worldwide'
  }, {
    icon: <Trophy className="h-12 w-12 text-blue-500" data-id="element-62" />,
    title: 'Opportunity Discovery',
    description: 'Find your next team, player, university or business opportunity'
  }];
  return <section id="features" className="py-16 bg-white" data-id="element-63">
      <div className="container mx-auto px-4" data-id="element-64">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-65">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-66">
              <div className="flex justify-center mb-4" data-id="element-67">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-68">{feature.title}</h3>
              <p className="text-gray-600" data-id="element-69">{feature.description}</p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-70">
          <h2 className="text-3xl font-bold mb-6" data-id="element-71">JOIN THE TEAM!</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-72">
            CONNECTING THE SPORTS WORLD THROUGH EASY NETWORKING
          </p>
        </div>
      </div>
    </section>;
}